import * as Config from '../../../../../config';
import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import GridGenres from '../../../content/grid/GridGenres';

function ConnectedGenresManager({ url, id, dimension }) {
  const { width } = dimension;

  const customOrderFilter = (base, x, i) => {
    const year = dayjs().format(`YYYY`);
    const playlists = [
      { id: 46095, name: 'The 20' },
      { id: 47907, name: 'Monthly Top Picks' },
      { id: 48298, name: 'Club Sets' },
      { id: 48301, name: 'Learn-To-Mix' },
      { id: 48309, name: 'Weddings' },
      { id: 48295, name: 'New Hits & Must-Haves' },
      { id: 112803, name: 'Open Format Sets' },
      { id: 48333, name: 'Decades Collections' },
    ]

    // if (x.person)
    // console.log('before', i, x.id, x.name.toLowerCase(), '---', x.person.id, '---', x.genre.name, '---', x.genre.id, '---', id,  x.publish_date, x.change_date, x)

    playlists.forEach( playlist => {
      if (x.person && x.person.id === playlist.id && x.genre.id === id && x.change_date && x.change_date.includes(year)) {
        if (!base.some( y => y.name === playlist.name)) {
          x.name = playlist.name;
          base.push(x);
        }
      }
    })

    return base;
  }

  return (
    <>
      {/* <GridCharts title={`Playlists`} id={`{B}beatsource_playlists_slice`}
        width={ width - Config.SUB_SIDEBAR} rowCount={2} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD) * 2) + Config.GRID_COVER_PAD }
        hasPagination={true} allTo={`${url}/playlists`} allLabel={`View All`}
        arrowLeftStyle={{ position: `absolute`, right: width - Config.SUB_SIDEBAR + 13, bottom: (Config.CARD_HEIGHT + Config.CARD_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1) + 13, bottom: (Config.CARD_HEIGHT + Config.CARD_PAD) * -1 }}
        pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=60&chart_genre_id=${id}`}
        className={`grid-chart`}
      /> */}
      <GridGenres title={`Playlists`} id={`{B}beatsource_playlists_slice`}
        width={ width - Config.SUB_SIDEBAR } rowCount={1} height={Config.CARD_HEIGHT + (Config.GRID_PAD * 2)} rowHeight={Config.CARD_HEIGHT + (Config.GRID_PAD * 2)}
        hasPagination={false} allTo={`${url}/playlists`} allLabel={`View All Playlists`}
        pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=200&chart_genre_id=${id}&updated=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:`}
        className={`grid-chart`} customReduceFormat={customOrderFilter} showLoading={true} showTitle={true}
      />
    </>
  );
}

ConnectedGenresManager.propTypes = {
  url: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired
}

const GenresManager = connect(
  state => ({
    dimension: state.dimension
  })
)(ConnectedGenresManager);

export default GenresManager;
